<script setup>
import { ref,inject,onMounted,provide  } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import { useMemberStore } from '../../stores';
import JSONbig from "json-bigint";

const userStore = useMemberStore();
const baseURL = 'https://devmini.walkertour.cn';
const rootPath = "/www/wwwroot/testMiniServer/server/dist";

const billid = inject('billid');
const forbidEdit = inject('forbidEdit');
const size = ref('default')
const labelPosition = ref('right')
const sizeForm = inject('orderForm');
const typeOptions = ref([])
const imageUrl = ref('')
const headers = ref({
	'Authorization': `${userStore.profile?.token}`,
})
onMounted(async()=>{
	if(billid.value!=null&&billid.value!=''){
		const response = await axios.post('/klook/driver/queryInfo', {
		  billid:billid.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			sizeForm.value = JSONbig.parse(response.data.data);
			imageUrl.value = sizeForm.value.cover_image
		}
	}
	const response = await axios.get('/klook/driver/queryOtherContact', {
	  headers: {
		'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(response.data.status===0){
		typeOptions.value = response.data.data
	}
})
const addJtgj=()=>{
	sizeForm.value.other_contact.push({
		type:'',
		content:''
	})
}
const handleAvatarSuccess = (
  response,
  uploadFile
) => {
	if(response.status===0){
		imageUrl.value = response.imgUrl.replace(rootPath,baseURL);
		sizeForm.value.avatar = response.imgUrl;
	}
}

const beforeAvatarUpload = (rawFile) => {
  if (rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
    ElMessage.error('Avatar picture must be JPG/PNG format!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 20) {
    ElMessage.error('Avatar picture size can not exceed 20MB!')
    return false
  }
  return true
}
const delItem=(index)=>{
	sizeForm.value.other_contact.splice(index,1)
}
</script>
<template>
	<el-form
	    ref="form"
	    :model="sizeForm"
	    label-width="auto"
	    :label-position="labelPosition"
	    :size="size"
	  >
		<div style="display: flex;">
			<el-form-item label="名" style="width: 48%;">
			  <el-input :disabled="forbidEdit" class="w-50 m-2" v-model="sizeForm.first_name" />
			</el-form-item>
			<el-form-item label="姓" style="width: 48%;">
			  <el-input :disabled="forbidEdit" class="w-50 m-2" v-model="sizeForm.last_name" />
			</el-form-item>
		</div>
		<div style="display: flex;">
		  <el-form-item label="手机号" style="width: 48%;">
			<el-input :disabled="forbidEdit" class="w-50 m-2" v-model="sizeForm.telephone" />
		  </el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="头像">
				<el-upload
			      class="avatar-uploader"
			      action="/manageDriver/driver/uploadFile"
				  :headers="headers"
			      :show-file-list="false"
			      :on-success="handleAvatarSuccess"
			      :before-upload="beforeAvatarUpload"
				  crossorigin="anonymous"
			    >
			      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
			      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
			    </el-upload>
			</el-form-item>
		</div>
		<div>
			<el-form-item label="其他联系方式" style="width: 92%;">
				<el-button type="primary" @click="addJtgj">新增</el-button>
			</el-form-item>
		</div>
		<div v-for="(input, index) in sizeForm.other_contact" :key="index" style="margin-top: 10px;width:92%;display: flex;align-items: center;">
		  <el-text class="mx-1" type="primary" style="width: 96px;">序号{{index+1}}</el-text>
		  <el-select
		      v-model="input.type"
		      placeholder="Select"
		      style="width: 240px"
			  :disabled="forbidEdit"
		    >
		      <el-option
		        v-for="item in typeOptions"
		        :key="item.value"
		        :label="item.label"
		        :value="item.value"
		      />
		  </el-select>&nbsp;
		  <el-input :disabled="forbidEdit" v-model="input.content" placeholder="联系方式详细"></el-input>&nbsp;
		  <el-icon @click="delItem(index)"><Minus /></el-icon>
		</div>
	  </el-form>
</template>

<style scoped>
	.avatar-uploader .avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatar-uploader .el-upload {
	  border: 1px dashed var(--el-border-color);
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	  transition: var(--el-transition-duration-fast);
	}
	
	.avatar-uploader .el-upload:hover {
	  border-color: var(--el-color-primary);
	}
	
	.el-icon.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 90px;
	  height: 90px;
	  text-align: center;
	}
</style>